import React, { useState } from 'react';
import UbyportAdmin from './UbyportAdmin';
import AdminUbyportTest from './AdminUbyportTest';

type Section = 'config' | 'test';

const AdminUbyportPage: React.FC = () => {
  const [section, setSection] = useState<Section>('config');

  return (
    <div className="page-container">
      <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: 4, color: '#1a202c' }}>Ubyport</h1>
      <p style={{ color: '#718096', marginBottom: 16, fontSize: '0.9rem' }}>
        Configuration, codebook management, and batch testing
      </p>

      <div style={{ display: 'flex', gap: 4, marginBottom: 0, borderBottom: '2px solid #e2e8f0' }}>
        {(['config', 'test'] as Section[]).map(s => (
          <button
            key={s}
            onClick={() => setSection(s)}
            style={{
              padding: '10px 20px',
              background: section === s ? 'var(--brand)' : 'transparent',
              color: section === s ? '#fff' : '#4a5568',
              border: 'none',
              borderRadius: '6px 6px 0 0',
              fontWeight: 600,
              fontSize: '0.9rem',
              cursor: 'pointer',
            }}
          >
            {s === 'config' ? 'Configuration' : 'Batch Test'}
          </button>
        ))}
      </div>

      <div style={{ paddingTop: 4 }}>
        {section === 'config' && <UbyportAdmin />}
        {section === 'test' && <AdminUbyportTest />}
      </div>
    </div>
  );
};

export default AdminUbyportPage;
